import { useEffect, useMemo } from 'react'
import { useUserState } from '~/atoms/UserState'
import Logger from '~/services/Logger'

const useCloudwatchLogger = (tag: string): { logger?: Logger } => {
  const { pbxId, sessionUser } = useUserState()

  const logger = useMemo(() => {
    try {
      if (pbxId === undefined || sessionUser?.id === undefined) {
        return new Logger(tag)
      }

      return new Logger(tag, { pbxId, userId: sessionUser.id })
    } catch (e) {
      console.error('Error creating logger', e)
      return undefined
    }
  }, [pbxId, sessionUser, tag])

  // Flush any leftover events before the useCloudwatchLogger is unmounted by component
  useEffect(() => {
    return () => {
      logger?.flush()
    }
  }, [logger])

  return {
    logger,
  }
}

export default useCloudwatchLogger
